module.exports = __webpack_public_path__ + "img/1-low.020b9b12.jpg";